module.exports = __webpack_public_path__ + "static/img/brees-2008-img-in-copy.aca6aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-img-in-copy.png
// module id = OBhv
// module chunks = 1